import React, { Component, PropTypes } from 'react';
import { composeUrlFromUrlParams } from '../UrlUtils';
import { history } from '../../modules/App/AppContainer';
import { connect } from 'react-redux';

class BasemapDialogueItem extends Component {

  constructor(props) {
    super(props);
    this.changeRoute = this.changeRoute.bind(this);
  }

  changeRoute() {
    const url = composeUrlFromUrlParams(this.props.urlParams, this.props.paramType, this.props.paramValue);
    history.push(url);
  }

  render() {
    let className = 'mt-menu-tab-item block mb-';
    if (!this.props.checked) {
      className += ' cursor--pointer';
    }
    return (
      <div className="label-wrapper">
        <label className={className}>
          <div className="input-type-image-wrapper">
            <input
              type="image"
              src={this.props.imgSrc}
              className="mt-menu-tab-item-input radio"
              onClick={this.changeRoute}
              value={this.props.checked}
              readOnly
            />
            <span className="block">{this.props.label}</span>
          </div>
        </label>
      </div>
    );
  }
}

BasemapDialogueItem.propTypes = {
  paramType: PropTypes.string,
  paramValue: PropTypes.string,
  label: PropTypes.string,
  checked: PropTypes.bool,
  inputType: PropTypes.string,
  imgSrc: PropTypes.string,
};

export default connect(state => state.AppState)(BasemapDialogueItem);



/** WEBPACK FOOTER **
 ** ./apps/maptool/components/ShortcutMenu/BasemapDialogueItem.js
 **/